import { ROLES } from "@/data/interfaces/RolesEnum";
import api from "@/services/api";

export interface InviteData {
  name: string;
  surname: string;
  email: string;
  phone: string;
  role: ROLES;
}

export interface InvitePatientData {
  name: string;
  surname: string;
  email: string;
  phone: string;
  city: string;
  productId: number;
  /** Number of months the membership price is split across (1 = single payment). */
  paymentMonths: number;
  /** Percentage discount to apply to the invoice. 0 means no discount. */
  discountPercent: number;
  /** Used only by the UI to choose invite flow; not sent to the patient invite API. */
  role: ROLES;
}

/**
 * POST /api/invitation/patient — OpenAPI: Admin - Patients, "Invite a new patient".
 *
 * The backend may answer with HTTP 200 but `{ status: "error", message: ... }`
 * in the body (e.g. when Robolabs invoice generation fails after the user is
 * created). Treat any non-`"success"` status as an error so callers' `catch`
 * blocks fire instead of silently showing a success toast.
 */
const invitePatient = async (data: InvitePatientData) => {
  const {
    name,
    surname,
    email,
    phone,
    city,
    productId,
    paymentMonths,
    discountPercent,
  } = data;
  const resp = await api.post("/invitation/patient", {
    name,
    surname,
    email,
    phone,
    city,
    productId,
    paymentMonths,
    discountPercent,
  });

  const body = resp.data as
    | { status?: string; message?: string; data?: unknown }
    | undefined;

  if (body?.status && body.status !== "success") {
    throw new Error(body.message || "Nepavyko išsiųsti pakvietimo");
  }

  return resp;
};

const invite = async (data: InviteData) => {
  return await api.post("/invitations", {
    ...data,
    clinic_id: import.meta.env.VITE_CLINIC_ID,
  });
};

export default {
  invite,
  invitePatient,
};
